// extracted by extract-css-chunks-webpack-plugin
module.exports = {"lime-tint-lp-2":"#E8FDAC","blue-dark":"#02427E","container":"_36R76b"};